// extracted by mini-css-extract-plugin
export default {"button":"button_button__2Afos","pulse":"button_pulse__0qUfM","success":"button_success__YKsfZ"};